
<div class="sidebar border-end " *ngIf="role!='Device'"  [ngClass]="{'collapsed': isCollapsed}">
    <div class="">

    <!-- Sidebar Header -->
    <div class="sidebar-header  pr-0 mt-1 rounded text-center">
        <div class="py-2" style="background-color: #132a42;" *ngIf="!isCollapsed">
      <h6 class="font-weight-bolder" *ngIf="!isCollapsed">{{ username }}</h6>
      <span class="p-0 m-0 w-100"  *ngIf="!isCollapsed">{{ role }}</span>
    </div>
      <div class="initials-circle" *ngIf="isCollapsed">{{ nameInitials }}</div>
    </div>
    <hr class=" my-1">
        <button (click)="toggleSidebar()" class="btn toggle-btn " 
        [ngClass]="{'collapsed': isCollapsed, 'expanded': !isCollapsed}">
        <i class="fa" [ngClass]="{'fa-chevron-left': !isCollapsed, 'fa-chevron-right': isCollapsed}"></i>
     
        </button>
        
    </div>

    <!-- Toggle button for the sidebar -->


   

    <ul class="list-group" style="">

        <li class="list-group-item border-0 " style=" cursor: pointer;" routerLink="/main-dashboard"
        *ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()"
        >
        <a class="d-flex align-items-center" routerLink="/main-dashboard"><i class="fa fa-tachometer-alt fa-2x"></i> <span class="p-2" 
                style="  cursor: pointer;  "*ngIf="!isCollapsed" translate
                >Dashboard</span></a>
    </li>


    <li class="list-group-item border-0 " style=" cursor: pointer;" routerLink="/sales-rep-timetable"
    *ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()">
    <a class="d-flex align-items-center " ><i class="fa fa-calendar-day"></i> <span class="p-2 "
            style="  cursor: pointer;  " *ngIf="!isCollapsed" translate
            >Schedules</span></a>
</li>

<li class="list-group-item border-0" style=" cursor: pointer;" routerLink="/search-page"
*ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()">
<a class="d-flex align-items-center " ><i class="fa fa-search"></i> <span class="p-2 "
        style="  cursor: pointer;  " *ngIf="!isCollapsed" translate
        >Client Search</span></a>
</li>



<li class="list-group-item border-0" style=" cursor: pointer;" routerLink="/sales-rep-home"
*ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isSalesRep() || isSalesSupport() || isPowerUser() || isShipper()">
<a class="d-flex align-items-center "><i class="fa fa-home"></i> <span class="p-2 "
        style="cursor: pointer;" *ngIf="!isCollapsed"  translate>My
        Calendar</span></a>
</li>



<li class="list-group-item border-0 " style=" cursor: pointer;" routerLink="/all-local-appointments"
*ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()">
<a class="d-flex align-items-center " ><i class="fa fa-calendar-alt"></i><span class="p-2"
        style=" cursor: pointer;" routerLink="/all-local-appointments" *ngIf="!isCollapsed" translate>All Local
        Appointments</span></a>
</li>







    </ul>




    <hr>

  




    <ul class="list-group" style="">



        <li class="list-group-item border-0 " style=" cursor: pointer;"   *ngIf=" isSystemAdmin()">
            <a class="d-flex align-items-center"  aria-expanded="false" href="#hrmenu"
                data-toggle="collapse" data-target="#hrmenu"><i class="fa fa-cog"> </i><span class="p-2" *ngIf="!isCollapsed"
                     translate>Settings</span></a>
            <ul class=" collapse list-unstyled" *ngIf="!isCollapsed" id="hrmenu" aria-expanded="false">
            
                <li  class="ml-4"><a 
                        routerLink="/users" translate>User Administration</a></li>
                       
            
            
            </ul>
            </li>   







      <li class="list-group-item border-0" style=" cursor: pointer;"
      *ngIf="isSystemAdmin() || isAdmin() || isSuperUser() && isOntario()" >
      <a class="d-flex align-items-center" ria-expanded="false" href="#reportmenu" data-toggle="collapse"
          data-target="#reportmenu"><i class="fa fa-clipboard-list"></i> <span class="p-2" *ngIf="!isCollapsed"
                translate>Reports</span></a>

      <ul class="collapse list-unstyled "  id="reportmenu" *ngIf="!isCollapsed" 
          aria-expanded="false">

          <li class="ml-2"  *ngIf="isSystemAdmin() || isAdmin() || isSuperUser() && isOntario()">
              

                  <a  href="#reportfullmenu" data-toggle="collapse"
                  data-target="#reportfullmenu"><!--<i class="fa fa-clipboard-list"></i>--> <span class="p-2"*ngIf="!isCollapsed"
                      translate>Full Report</span></a>
                      <ul class="submenu collapse list-unstyled " *ngIf="!isCollapsed" id="reportfullmenu"
                      aria-expanded="false" >
                      <li class="ml-2" *ngFor="let year of years">
                          <a 
                         (click)="fullreportdashboard(year.name)">{{year.name}}</a>
                      </li>
                      </ul>
                  </li>

          <li class="ml-2">
            
                  <a  href="#reportbranchmenu" data-toggle="collapse"
                  data-target="#reportbranchmenu"><!--<i class="fa fa-clipboard-list"></i>--> <span class="p-2" *ngIf="!isCollapsed"
                       translate>Branch Report</span></a>
                      <ul class="submenu collapse list-unstyled " *ngIf="!isCollapsed" id="reportbranchmenu"
                      aria-expanded="false" >
                      <li class="ml-2" *ngFor="let year of years">
                          <a 
                         (click)="branchreportdashboard(year.name)">{{year.name}}</a>
                      </li>
                      </ul>

</li>



    </ul>
    </li>
    </ul>
  
  </div>
  









<!--<div *ngIf="role!='Device'" class=" collapse d-flex  bg-dark bg-faded text-white pt-3 mt-4 h-100 bottom-rounded"  [class.active]="sidebarshow"
    style=" min-height: 2500px; width: fit-content;" id="sidebar">
    <ul class="nav flex-column w-100 p-1">
        <div class="row border-bottom m-0  text-center  ">
           
            <div class="col-md-8 sidebar-header pt-2 mt-1 text-white  rounded "style="
            max-height: 115px; padding:0px">
                <h5 class="font-weight-bolder ">{{username}}</h5>
                <h6 class="p-0 m-0 w-100">{{role}}</h6>
                <h5 class="border rounded mt-1 w-100" style="font-size: small;">{{branch}}</h5>

                <strong>{{nameInitials}}</strong>
            </div>
            
                <div class="col-md-4 px-0 float-right text-white rounded" id='nav-menu-icon'
                    [class.open]="sidebarshow==false" (click)='onShowDetails()' style="text-align-last: right;">
                
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
           
           
        </div>
        <li class="nav-item " style=" cursor: pointer;" routerLink="/main-dashboard"
            *ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()"
            [class.active]="sidebarshow">
            <a class="nav-link " [class.active]="sidebarshow"><i class="fa fa-tachometer-alt"></i> <span class=" "
                    style="font-family:Trebuchet MS;  cursor: pointer;  " translate
                    >Dashboard</span></a>
        </li>

        <li class="nav-item " style=" cursor: pointer;" routerLink="/sales-rep-timetable"
            *ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()"
            [class.active]="sidebarshow">
            <a class="nav-link " [class.active]="sidebarshow"><i class="fa fa-calendar-day"></i> <span class=" "
                    style="font-family:Trebuchet MS;  cursor: pointer;  " translate
                    >Schedules</span></a>
        </li>

        <li class="nav-item " style=" cursor: pointer;" routerLink="/search-page"
        *ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()"
        [class.active]="sidebarshow">
        <a class="nav-link " [class.active]="sidebarshow"><i class="fa fa-search"></i> <span class=" "
                style="font-family:Trebuchet MS;  cursor: pointer;  " translate
                >Client Search</span></a>
    </li>

        <li class="nav-item" style=" cursor: pointer;" routerLink="/sales-rep-home"
            *ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isSalesRep() || isSalesSupport() || isPowerUser() || isShipper()"
            [class.active]="sidebarshow">
            <a class="nav-link " [class.active]="sidebarshow"><i class="fa fa-home"></i> <span class=" "
                    style="font-family:Trebuchet MS;   cursor: pointer;"  translate>My
                    Calendar</span></a>
        </li>



        <li class="nav-item " style=" cursor: pointer;" routerLink="/all-local-appointments"
            *ngIf="isAdmin() || isSystemAdmin() || isSuperUser() || isReceptionist() || isPowerUser()"
            [class.active]="sidebarshow">
            <a class="nav-link " [class.active]="sidebarshow"><i class="fa fa-calendar-alt"></i><span class=""
                    style="font-family:Trebuchet MS;  cursor: pointer;" routerLink="/all-local-appointments" translate>All Local
                    Appointments</span></a>
        </li>

       




        <li class="nav-item " style=" cursor: pointer;" [class.active]="sidebarshow"   *ngIf=" isSystemAdmin()">
            <a class="nav-link collapsed " [class.active]="sidebarshow" aria-expanded="false" href="#hrmenu"
                data-toggle="collapse" data-target="#hrmenu"><i class="fa fa-cog"> </i><span class=""
                    style="font-family:'DINPro';  " translate>Settings</span></a>
            <ul class="submenu collapse list-unstyled" [class.active]="sidebarshow" id="hrmenu" aria-expanded="false">

                <li class="nav-item pb-2" style=" font-family:'DINPro';   "><a class="nav-link py-1 "
                        routerLink="/users" translate>User Administration</a></li>
                       


            </ul>
        </li>   



        <li class="nav-item " style=" cursor: pointer;"
            *ngIf="isSystemAdmin() || isAdmin() || isSuperUser() && isOntario()" [class.active]="sidebarshow">
            <a class="nav-link collapsed " [class.active]="sidebarshow" href="#reportmenu" data-toggle="collapse"
                data-target="#reportmenu"><i class="fa fa-clipboard-list"></i> <span class=""
                    style="font-family:'DINPro';  " translate>Reports</span></a>

            <ul class="submenu collapse list-unstyled " [class.active]="sidebarshow" id="reportmenu"
                aria-expanded="false">

                <li class="nav-item pb-2" style=" font-family:'DINPro'; "  *ngIf="isSystemAdmin() || isAdmin() || isSuperUser() && isOntario()">
                    
    
                        <a class="nav-link collapsed " [class.active]="sidebarshow" href="#reportfullmenu" data-toggle="collapse"
                        data-target="#reportfullmenu"><i class="fa fa-clipboard-list"></i> <span class=""
                            style="font-family:'DINPro';  " translate>Full Report</span></a>
                            <ul class="submenu collapse list-unstyled " [class.active]="sidebarshow" id="reportfullmenu"
                            aria-expanded="false" >
                            <li *ngFor="let year of years">
                                <a class="nav-link py-1 "
                               (click)="fullreportdashboard(year.name)">{{year.name}}</a>
                            </li>
                            </ul>
                        </li>

                <li class="nav-item pb-2" style=" font-family:'DINPro'; ">
                  
                        <a class="nav-link collapsed " [class.active]="sidebarshow" href="#reportbranchmenu" data-toggle="collapse"
                        data-target="#reportbranchmenu"><i class="fa fa-clipboard-list"></i> <span class=""
                            style="font-family:'DINPro';  " translate>Branch Report</span></a>
                            <ul class="submenu collapse list-unstyled " [class.active]="sidebarshow" id="reportbranchmenu"
                            aria-expanded="false" >
                            <li *ngFor="let year of years">
                                <a class="nav-link py-1 "
                               (click)="branchreportdashboard(year.name)">{{year.name}}</a>
                            </li>
                            </ul>

</li>


            
            </ul>

        </li>


       
        <li class="nav-item pb-2" style=" font-family:'DINPro'; " *ngIf="isReceptionist() || isPowerUser() ">
           
                <a class="nav-link collapsed " [class.active]="sidebarshow" href="#reportbranchmenu" data-toggle="collapse"
                data-target="#reportbranchmenu"><i class="fa fa-clipboard-list"></i> <span class=""
                    style="font-family:'DINPro';  " translate>Branch Report</span></a>
                    <ul class="submenu collapse list-unstyled " [class.active]="sidebarshow" id="reportbranchmenu"
                    aria-expanded="false" >
                    <li *ngFor="let year of years">
                        <a class="nav-link py-1 "
                       (click)="branchreportdashboard(year.name)">{{year.name}}</a>
                    </li>
                    </ul>

</li>

        <script>
            function myAccFunc(divid) {
                var x = document.getElementById(divid);
                if (x.className.indexOf("w3-show") == -1) {
                    x.className += " w3-show";
                    x.previousElementSibling.className += " w3-blue";
                } else {
                    x.className = x.className.replace(" w3-show", "");
                    x.previousElementSibling.className =
                        x.previousElementSibling.className.replace(" w3-blue", "");
                }
            }
        </script>







    </ul>



</div>-->